import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IBusinessSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import useGetSelectOption from 'src/hooks/useGetSelectOption';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { ILabelValueModel, useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IBusinessSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const { getUseYn } = useGetSelectOption();
  const { categoryStore } = useStores();

  const methods = useForm<IBusinessSFilter>({
    defaultValues: { bnCatCd: '', useYn: '', searchText: '' },
  });

  // bnCatCd: 최상위 카테고리 옵션
  const CATEGORY_OPTIONS: ILabelValueModel[] = categoryStore.topLevelCategories.map((category) => ({
    label: category.categoryNm,
    value: category.categorySid,
  }));

  // useYn: 사용 여부 옵션
  const USEYN = getUseYn();

  // 검색 함수
  const onValid = (data: IBusinessSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true}>
        <FormItem>
          <RHFSelect
            label={t('business.fields.category.name')}
            name="bnCatCd"
            options={CATEGORY_OPTIONS}
          />
        </FormItem>
        <FormItem>
          <RHFSelect label={t('business.fields.useYn.name')} name="useYn" options={USEYN} />
        </FormItem>
        <FormItem size={2}>
          <RHFTextField label={t('business.fields.searchText.name')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
